import './styles.css'

function DownloadSettings({ fileType, onFileTypeChange }) {
  return (
    <div className="download-settings">
      <label className="download-settings-label">Tipo de Archivo</label>
      <div className="download-settings-options">
        <label className="radio-option">
          <input
            type="radio"
            name="fileType"
            value="xls"
            checked={fileType === 'xls'}
            onChange={(e) => onFileTypeChange(e.target.value)}
          />
          <span className="radio-label">Archivo Microsoft Excel (.xls)</span>
        </label>
        <label className="radio-option">
          <input
            type="radio"
            name="fileType"
            value="pdf"
            checked={fileType === 'pdf'}
            onChange={(e) => onFileTypeChange(e.target.value)}
          />
          <span className="radio-label">Archivo Adobe PDF (.pdf)</span>
        </label>
        {/* <label className="radio-option">
          <input
            type="radio"
            name="fileType"
            value="png"
            checked={fileType === 'png'}
            onChange={(e) => onFileTypeChange(e.target.value)}
          />
          <span className="radio-label">Archivo de Imagen (.png)</span>
        </label> */}
      </div>
    </div>
  )
}

export default DownloadSettings
